<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="房源名称"
                ><a-input v-model="queryParam.houseName" placeholder="房源名称"
              /></a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="房源代码"
                ><a-input v-model="queryParam.houseNo" placeholder="房源代码"
              /></a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="楼号"
                  ><a-input v-model="queryParam.buildingNo" placeholder="楼号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="单元号"
                  ><a-input v-model="queryParam.unitNo" placeholder="单元号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="门牌号"
                  ><a-input v-model="queryParam.houseNum" placeholder="门牌号"
                /></a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="房号"
                  ><a-input v-model="queryParam.roomNum" placeholder="房号"
                /></a-form-item>
              </a-col>

              <a-col :md="8" :sm="24">
                <a-form-item label="是否有效">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="I">有效房源</a-select-option>
                    <a-select-option value="X">无效房源</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="出租状态">
                  <a-select
                    v-model="queryParam.rentSta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="0">未租</a-select-option>
                    <a-select-option value="1">已预订</a-select-option>
                    <a-select-option value="2">已出租</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="入住状态">
                  <a-select
                    v-model="queryParam.checkState"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="N">未入住</a-select-option>
                    <a-select-option value="Y">已入住</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="是否短租">
                  <a-select
                    v-model="queryParam.isShortRent"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="0">否</a-select-option>
                    <a-select-option value="1">是</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button
                  class="button-margin-left"
                  @click="() => (queryParam = {})"
                  >重置</a-button
                >
                <!-- <a-button
                  type="primary"
                  icon="plus"
                  @click="add"
                  v-hasAnyPermission="`houseinfo:add`"
                  class="button-margin-left"
                  >新建</a-button
                > -->
                <a @click="toggleAdvanced" class="button-margin-left">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        rowKey="id"
        :columns="columns"
        :data="loadData"
        :scroll="{ x: 2200 }"
        showPagination="auto"
      >
        <span slot="tagItem" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag class="render-tag" color="grey" v-if="record.sta == 'X'"
              >无效房源</a-tag
            >
          </template>
        </span>

        <span slot="rentSta" slot-scope="text">
          <template>
            <a-tag
              class="render-tag"
              :color="
                text == '0' ? '#108ee9' : text == '1' ? '#f50' : '#87d068'
              "
              >{{
                text == "0" ? "未出租" : text == "1" ? "已预订" : "已出租"
              }}</a-tag
            >
          </template>
        </span>

        <span slot="checkState" slot-scope="text">
          <template>
            <a-tag
              class="render-tag"
              :color="text == 'N' ? 'grey' : '#87d068'"
              >{{ text == "N" ? "未入住" : "已入住" }}</a-tag
            >
          </template>
        </span>
        <span slot="isSublet" slot-scope="text">
          <template>
            <a-tag class="render-tag" :color="text == 'T' ? '#108ee9' : ''">{{
              text == "T" ? "是" : "否"
            }}</a-tag>
          </template>
        </span>
        <span slot="isShortRent" slot-scope="text">
          <template>
            <a-tag class="render-tag" :color="text == '1' ? '#108ee9' : ''">{{
              text == "1" ? "是" : "否"
            }}</a-tag>
          </template>
        </span>
        <span slot="floor" slot-scope="text, record">
          <template>
            <span style="color: red;font-weight: bold;">{{ text }}</span
            >/{{ record.totalFloor }}
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              @click="action(record, 'info')"
              v-hasAnyPermission="`houseinfo:info`"
              >查看</a
            >
            <a-popconfirm
              title="确认停用?"
              @confirm="action(record, 'disabled')"
              v-if="record.sta == 'I'"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`houseinfo:disable`"
              ><a class="a-action">停用</a></a-popconfirm
            >

            <a-popconfirm
              title="确认启用?"
              @confirm="action(record, 'enabled')"
              v-if="record.sta == 'X'"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`houseinfo:disable`"
              ><a class="a-action">启用</a></a-popconfirm
            >

            <a-popconfirm
              title="确认上架?"
              v-if="record.rentSta == '2'"
              @confirm="action(record, 'up')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`houseinfo:updown`"
              ><a class="a-action">上架</a></a-popconfirm
            >

            <a-popconfirm
              title="确认下架?"
              v-if="record.rentSta == '0'"
              @confirm="action(record, 'down')"
              okText="确认"
              cancelText="取消"
              v-hasAnyPermission="`houseinfo:updown`"
              ><a class="a-action">下架</a></a-popconfirm
            >
          </template>
        </span>
      </s-table>
    </a-card>
    <!-- <circle-info
      ref="districtInfo"
      :provinceList="provinceList"
      :cityList="cityList"
      @success="$refs.table.refresh(true)"
    ></circle-info> -->
  </page-view>
</template>

<script>
import moment from "moment";
import { STable } from "@/components";
import { PageView } from "@/layouts";
// import CircleInfo from "./CircleInfo.vue";

export default {
  name: "HouseList",
  components: {
    STable,
    PageView
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      provinceList: [],
      cityList: [],
      tmpCityList: [],
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: "房源代码",
          dataIndex: "houseNo",
          scopedSlots: { customRender: "tagItem" },
          fixed: "left"
        },
        {
          title: "楼号",
          dataIndex: "buildingNo",
          fixed: "left"
        },
        {
          title: "单元号",
          dataIndex: "unitNo",
          fixed: "left"
        },
        {
          title: "门牌号",
          dataIndex: "houseNum",
          fixed: "left"
        },
        {
          title: "房号",
          dataIndex: "roomNum",
          fixed: "left"
        },
        {
          title: "租金(元/月)",
          dataIndex: "rent",
          fixed: "left"
        },
        {
          title: "出租状态",
          dataIndex: "rentSta",
          scopedSlots: { customRender: "rentSta" },
          width: 100
        },
        {
          title: "入住状态",
          dataIndex: "checkState",
          scopedSlots: { customRender: "checkState" },
          width: 100
        },
        {
          title: "面积(㎡)",
          dataIndex: "roomArea",
          width: 90
        },
        {
          title: "是否短租",
          dataIndex: "isShortRent",
          scopedSlots: { customRender: "isShortRent" },
          width: 100
        },
        {
          title: "是否转租",
          dataIndex: "isSublet",
          scopedSlots: { customRender: "isSublet" },
          width: 100
        },
        {
          title: "当前楼层",
          dataIndex: "floor",
          scopedSlots: { customRender: "floor" },
          width: 100
        },
        {
          title: "房源名称",
          dataIndex: "houseName",
          width: 200,
          ellipsis: true
        },
        {
          title: "房源描述",
          dataIndex: "roomIntro",
          width: 250,
          ellipsis: true
        },
        {
          title: "操作人",
          dataIndex: "modifyUser",
          width: 100
        },
        {
          title: "更新时间",
          dataIndex: "modifyDatetime",
          width: 300
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return this.$http.roomBksApi
          .pageHouseInfo(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {
    let query = this.$route.query;
    if (query.param) {
      this.queryParam = Object.assign({}, this.queryParam, query.param);
    }
    this.getBaseHelpCode();
  },
  methods: {
    /**
     * 操作
     * @param {Object} record
     * @param {Object} type
     */
    action(record, type) {
      if (type == "info") {
        this.$router.push({
          name: "HouseInfo",
          query: {
            houseNo: record.houseNo,
            keeperNo: record.keeperNo,
            param: this.queryParam
          }
        });
      } else if (type == "down" || type == "up") {
        this.$http.roomBksApi
          .saveUpDownHouseInfo({
            type: type,
            houseNo: record.houseNo
          })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      } else if (type == "disabled" || type == "enabled") {
        this.$http.roomBksApi
          .saveDisableEnableHouseInfo({
            type: type,
            houseNo: record.houseNo
          })
          .then(res => {
            if (res.result == 0) {
              this.$refs.table.refresh(true);
              this.$message.success(res.msg);
            }
          });
      }
    },
    add() {
      this.$refs.districtInfo.showModal("add", null);
    },
    /**
     * 展开/收起查询条件
     */
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    getBaseHelpCode() {
      this.$http.systemBksApi
        .findProvinceCityDistrictCircleHelpCode({
          isProvince: "T",
          isCity: "T"
        })
        .then(res => {
          this.provinceList = res.resultObject.provinceList;
          this.cityList = res.resultObject.cityList;
        });
    },
    handleProvinceChange(value) {
      let arr = [];
      for (let city of this.cityList) {
        if (city.provinceCode == value) {
          arr.push(city);
        }
      }
      this.tmpCityList = arr;
    }
  }
};
</script>
